module.exports = __webpack_public_path__ + "img/sup_kyc_7.46fde3df.jpg";